import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
var _templateObject;
import { css } from '@emotion/react';
import { purple800 } from './palette';
export var disabled = {
  opacity: 0.6,
  cursor: 'default'
};
export var stripBtnStyles = {
  cursor: 'pointer',
  background: 'transparent',
  outline: 'none',
  border: 'none'
};
export var ellipsis = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap'
};
export var ellipsisCss = css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\twhite-space: nowrap;\n"])));
export var focusRadius = {
  borderRadius: '2px'
};
export var focusInset = _objectSpread(_objectSpread({}, focusRadius), {}, {
  boxShadow: "inset 0 0 0 1px ".concat(purple800)
});
export var focusInsetThick = _objectSpread(_objectSpread({}, focusRadius), {}, {
  boxShadow: "inset 0 0 0 2px ".concat(purple800)
});
export var focusOutset = _objectSpread(_objectSpread({}, focusRadius), {}, {
  boxShadow: "0 0 0 1px ".concat(purple800)
});
export var focusOutsetThick = _objectSpread(_objectSpread({}, focusRadius), {}, {
  boxShadow: "0 0 0 2px ".concat(purple800)
});
var shadowColor = 'rgba(0,0,0,0.24)';
export var shadow1 = {
  boxShadow: "0px 1px 2px ".concat(shadowColor)
};
export var shadow2 = {
  boxShadow: "0px 1px 5px ".concat(shadowColor)
};
export var shadow3 = {
  boxShadow: "0px 1px 16px ".concat(shadowColor)
};
export var shadow4 = {
  boxShadow: "0px 1px 24px ".concat(shadowColor)
};
export var overlay = 'rgba(0,0,0,0.4)';